// extracted by mini-css-extract-plugin
export default {"wipe":"Wipe_wipe__3lSS7","door":"Wipe_door__I6kbh","close":"Wipe_close__1LwAu","open":"Wipe_open__2t6P+"};